export class SubCategory {
  constructor(id = "", name = "", icon = "", image = "", slug_url = "") {
    this.id = id;
    this.name = name;
    this.image = image;
    this.icon = icon;
    this.slug_url = slug_url;
  }
}
